import Modal from "../components/modal";
import react from 'react';

export default class RoutePlaningInfoModal extends react.Component {
  constructor(props) {
    super(props);

    this.state = { 
      show: props.show,
      hideAction: props.hideAction
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside() {
    this?.state?.hideAction && this?.state.hideAction();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ show: nextProps.show });  
  }

  render() {
    return (
      <>
        <Modal show = {this.state.show} header = { "Route planning generators" } hideAction = {this.state.hideAction}>
          <div>
            <div className="mb-6">
              <h3 className="h4-font-size subheading">Field</h3>
              <p>This generator will create a route that will cover an area. You can define your area and set angle and distance of a rows. Also you can choose if you want a route around the perimeter.</p>
              <img src="./generators-field.png" alt="Fill a field generator" className="d-block mx-auto object-fit-cover rounded" />
            </div>
            <div className="mb-6">
              <h3 className="h4-font-size subheading">Obstacles</h3>
              <p>This generator will find the best way around obstacles. </p>
              <img src="./generators-obstacles.png" alt="Find the best route generator" className="d-block mx-auto object-fit-cover rounded" />
            </div>
            <div className="mb-6">
              <h3 className="h4-font-size subheading">Points</h3>
              <p>This generator will find the best way through defined points. The points can be directed or undirected.</p>
              <img src="./generators-points.png" alt="Route through points generator" className="d-block mx-auto object-fit-cover rounded" />
            </div>
          </div>
        </Modal>
      </>
    );
  }
};